"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionAccommodationResponseSchema = exports.RegionAccommodationParamsSchema = void 0;
var zod_1 = require("zod");
exports.RegionAccommodationParamsSchema = zod_1.z.object({
    type: zod_1.z.string(),
});
var BaseRegionAccommodation = zod_1.z.object({
    /** 지역(지하철)코드 */
    code: zod_1.z.string().nullable(),
    /** 지역(지하철)명 */
    title: zod_1.z.string().nullable(),
    /** 지역(지하철) 서브 타이틀(e.g 전체, 야놀자 초이스) */
    subTitle: zod_1.z.string().nullable(),
    /** 깊이, 재귀적인 트리 구조를 만들때 사용하는 깊이 값 */
    depth: zod_1.z.number(),
    /** 정렬할 때 사용하는 정렬순서 */
    order: zod_1.z.number(),
    option: zod_1.z
        .object({
        /** 숙소 상권 지역 옵션 */
        accommodation: zod_1.z
            .object({
            /** 인기지역 */
            popular: zod_1.z.boolean(),
            /** TOP 광고 */
            topAdvertise: zod_1.z.boolean(),
            /** XX 전체 */
            whole: zod_1.z.boolean(),
            /**
             * 광고 갯수를 위한 정보
             * [8.12.0 추가] 초이스(top)광고 더 많이 노출
             * joy region3 응답에 전달되는 topAdvertiseMore를 클라이언트에서 전달 해주기로 했다.
             * 2022-02-28 현재 인기지역, 상위지역 전체 인 경우 광고를 더 많이 노출해달라는 요청이었다.
             */
            topAdvertiseMore: zod_1.z.number(),
        })
            .optional(),
        /** 지하철 옵션 (호선 색상, 위도, 경도) */
        subway: zod_1.z
            .object({
            /** 노선색상 */
            lineColor: zod_1.z.string().nullable(),
            /** 지하철역 위도 */
            latitude: zod_1.z.number().nullable(),
            /** 지하철역 경도 */
            longitude: zod_1.z.number().nullable(),
        })
            .optional(),
    })
        .nullable(),
    /** log */
    logMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.RegionAccommodationResponseSchema = BaseRegionAccommodation.extend({
    /** 자식 지역명. 예를들어, 서울지역은 자식 지역으로 강남, 강북과 같은 지역을 가진다. */
    items: zod_1.z.array(zod_1.z.lazy(function () { return exports.RegionAccommodationResponseSchema; })).default([]),
});
